/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export enum VideoStreamStatus {
        'OFFLINE',
        'ONLINE',
        'LIVE',
    }

    export interface IMonitor {
        id: number;
        href: string;
        name: string;
        source: string;
        monitorRoom: string;
        numOrder: number;
        streamPipe?: Models.IStreamPipe;   // used in grid monitoring room
        monitorGrid?: Models.IGridMonitor; // used in monitoring room
        totalMonitorInRoom: number;
        alarmsInfo?: IMonitorAlarmInfo;
    }

    
    export interface IMonitorVideoStream {
        name: string;
        href: string;
        sourceName: string;
        sinkName: string;
        status: VideoStreamStatus;
    }

    export interface IMonitorHrefs {
        srcBlockHref: string,
        sinkBlockHref: string,
        srcHref: string,
        sinkHref: string,
        extraHrefs?: string[],
        extraBlockHrefs?: string[],
    }

    export interface IMonitorAlarmInfo {
        currentCriticals: IMonitorCriticalAlarm[],
        allCount: number,
        criticalsCount: number,
        showAllAlarms: boolean,
        showCriticalAlarms: boolean
    }

    export interface IMonitorCriticalAlarm {
        alarmName: string;
        deviceSimplifiedHref: string
    }

    export class Monitor implements IMonitor {
        public id: number;
        public href: string;
        public name: string;
        public source: string;
        public monitorRoom: string;
        public numOrder: number;
        public monitorGrid?: Models.IGridMonitor;
        public totalMonitorInRoom: number;

        public static Empty(): Monitor {
            return new Monitor();
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.name = '';
            this.source = '';
            this.numOrder = undefined;
            this.monitorRoom = '';
            this.totalMonitorInRoom = 0;
        }
    }

    export class MonitorVideoStream implements IMonitorVideoStream {
        public href: string;
        public sourceName: string;
        public sinkName: string;
        public status: VideoStreamStatus;
        public name: string;

        public static Empty(): MonitorVideoStream {
            return new MonitorVideoStream();
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.sourceName = '';
            this.sinkName = '';
            this.status = VideoStreamStatus.OFFLINE;
            this.name = '';
        }
    }

    export class MonitorStatus {
        public static ONLINE: string = 'ONLINE';
        public static OFFLINE: string = 'OFFLINE';
        public static PENDING: string = 'PENDING';
    }
}